// Creator status constants with colors and labels
export interface CreatorStatus {
  value: string;
  label: string;
  color: string;
  backgroundColor: string;
}

export const CREATOR_STATUS_OPTIONS: CreatorStatus[] = [
  {
    value: 'high potential',
    label: 'high potential',
    color: '#2d5016',
    backgroundColor: '#a4d65e'
  },
  {
    value: 'needs to negotiate',
    label: 'needs to negotiate',
    color: '#8b4513',
    backgroundColor: '#ffa366'
  },
  {
    value: 'in negotiation',
    label: 'in negotiation',
    color: '#ffffff',
    backgroundColor: '#4a148c'
  },
  {
    value: 'done',
    label: 'done',
    color: '#ffffff',
    backgroundColor: '#4a5568'
  },
  {
    value: 'not relevant',
    label: 'not relevant',
    color: '#ffffff',
    backgroundColor: '#6b7280'
  },
  {
    value: 'suspicious',
    label: 'suspicious',
    color: '#ffffff',
    backgroundColor: '#dc2626'
  }
];

// Legacy status options (for backward compatibility)
export const LEGACY_STATUS_OPTIONS = [
  { value: '', label: 'Select status' },
  { value: 'active', label: 'Active' },
  { value: 'pending', label: 'Pending' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'inactive', label: 'Inactive' }
];

// Helper functions
export const getStatusColor = (status: string): { color: string; backgroundColor: string } => {
  const statusOption = CREATOR_STATUS_OPTIONS.find(option => option.value === status);
  if (statusOption) {
    return {
      color: statusOption.color,
      backgroundColor: statusOption.backgroundColor
    };
  }
  // Default color for unknown status
  return {
    color: '#666666',
    backgroundColor: '#f0f0f0'
  };
};

export const getStatusLabel = (status: string): string => {
  const statusOption = CREATOR_STATUS_OPTIONS.find(option => option.value === status);
  return statusOption ? statusOption.label : status;
};

export const isValidStatus = (status: string): boolean => {
  return CREATOR_STATUS_OPTIONS.some(option => option.value === status);
};

// Export for easy importing
export default CREATOR_STATUS_OPTIONS;